import oversea from './area-permissions/oversea';

export const DEPLOY_AREA = {
  OVERSEA: 'oversea',
};

const isOversea = process.env.DEPLOY_AREA === DEPLOY_AREA.OVERSEA;
export function getPermissions() {
  let result = {};

  if (isOversea) {
    result = { ...oversea };
  }

  return result;
}



// WEBPACK FOOTER //
// ./src/permission/helper.js